import { FC } from 'react';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Breadcrumbs from 'components/Breadcrumbs';
import DashboardFlightsCardSkeleton from 'components/DashboardFlightsCardSkeleton';

type Props = {};

const DashboardSkeleton: FC<Props> = props => {
  return (
    <Box>
      <Breadcrumbs breadcrumbs={[]} />

      <Grid container spacing={2}>
        <DashboardFlightsCardSkeleton />
      </Grid>
    </Box>
  );
};

export default DashboardSkeleton;
